<script lang='ts'>
  import type { Storefront, StorefrontFeaturedProduct } from 'app/javascript/shared/javascripts/types/Storefront';
  import { selectAlternatives, waitForElementToDisplay } from '@distributor/svelte/Storefront/Utils/AlternativesUtils.svelte';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import { stagedRolloutCheck } from '@shared/svelte/Modules/StagedRolloutCheck.svelte';
  export let storefront : Storefront;
  export let callbacks: any;
  import FeaturedProduct from './FeaturedProduct.svelte';
  import { onMount } from 'svelte';

  function deleteProductPairSide(side:string, alternative:boolean) {
    let index = alternative ? 1 : 0
    let chosenProduct:StorefrontFeaturedProduct = selectAlternatives(storefront, side)[index]
    storefront.storefront_featured_products_attributes = [{
      id: chosenProduct.id,
      _destroy: true
    }];
    callbacks.update(storefront);
  }

  function swapDefaults(side:string) {
    let curDefault:StorefrontFeaturedProduct = selectAlternatives(storefront, side)[0]
    let newDefault:StorefrontFeaturedProduct = selectAlternatives(storefront, side)[1]
    storefront.storefront_featured_products_attributes = [{
      id: curDefault.id,
      alternative_index: 1,
      preview_alternative_index: 1
    },
    {
      id: newDefault.id,
      alternative_index: 0,
      preview_alternative_index: 0
    },
    ];
    callbacks.setLoading(true);
    curTab[side] = 'default';
    callbacks.update(storefront);
  }

  function swapPreview(side, switchingToIndex:number) {
    const otherInd = switchingToIndex == 1 ? 0 : 1
    const alts:StorefrontFeaturedProduct[] = selectAlternatives(storefront, side)

    const toShow:StorefrontFeaturedProduct = alts.find((x) => x.alternative_index === switchingToIndex)
    const toNotShow:StorefrontFeaturedProduct = alts.find((x) => x.alternative_index === otherInd)

    let toSend = []
    if (toShow) {
      toSend.push({
        id: toShow.id,
        preview_alternative_index: 0
      })
    }
    if (toNotShow) {
      toSend.push({
        id: toNotShow.id,
        preview_alternative_index: 1
      })
    }

    storefront.storefront_featured_products_attributes = toSend;
  }

  const allowAlternatives = stagedRolloutCheck('distributor_storefront_alternatives')
  let curTab = {'left': 'default', 'right': 'default'}
  const sideTitle = {'left': 'Left', 'right': 'Right'}

  let switchingToIndex:number;
  function switchTo(side:string, selection:string, runUpdate:boolean) {
    curTab[side] = selection;

    if (runUpdate) {
      callbacks.setLoading(true);
      switchingToIndex = (curTab[side] == 'default') ? 0 : 1
      swapPreview(side, switchingToIndex);
      callbacks.update(storefront);
      let altScrollId = selection == 'alternative' ? '_' + selection : '';
      let scrollId = `#inner_edit_featured_items${altScrollId}_${side}`;
      waitForElementToDisplay(scrollId, 300, 3000, function(scrollEl) {
        if (scrollEl) {
          scrollEl.scrollIntoView({block: "center", inline: "nearest", behavior: "smooth"});
        }
      });
    }
  }

  onMount(function() {
    let currentLeftDefault:StorefrontFeaturedProduct = selectAlternatives(storefront, 'left')[0]
    let currentRightDefault:StorefrontFeaturedProduct = selectAlternatives(storefront, 'right')[0]
    if (currentLeftDefault?.preview_alternative_index == 1) {
      switchTo('left', 'alternative', false)
    }
    if (currentRightDefault?.preview_alternative_index == 1) {
      switchTo('right', 'alternative', false)
    }
  })
  $: curAlt = selectAlternatives(storefront, 'left')[1]?.product_line_id && selectAlternatives(storefront, 'right')[1]?.product_line_id
</script>

{#if storefront.enable_featured_items}
  {#each ['left', 'right'] as side}
    {#if allowAlternatives}
      <ul class="fizz-tab-list">
        <li class:fizz-is-active={curTab[side] == 'default'} id='switch-to-default-{side}'
          on:click={() => switchTo(side, 'default', true)}>Default</li>
        <li class:fizz-is-active={curTab[side] == 'alternative'} id='switch-to-alternative-{side}'
          on:click={() => switchTo(side, 'alternative', true)}>Alternate</li>
      </ul>
    {/if}
    {#if curTab[side] == 'default'}
      <dd id="{'inner_edit_featured_items_' + side}">
        <section id="{side}-featured-item" class='fizz-text-small'>
          <p class="fizz-label fizz-space-between fizz-stack-16">{sideTitle[side]} Item
            {#if allowAlternatives}
              <Icon
                width="16"
                height="16" onPress={() => deleteProductPairSide(side, false)}
                type="Trash" extraClassNames='cursor-pointer'
              ></Icon>
            {/if}
          </p>
          {#if !storefront.loading}
            <FeaturedProduct {storefront} {callbacks} orientation={side}></FeaturedProduct>
          {/if}
        </section>
      </dd>
    {/if}

    {#if curTab[side] == 'alternative'}
      <dd id="{'inner_edit_featured_items_alternative_' + side}">
        <section id="{side}-featured-item-alternative" class='fizz-text-small'>
          <p class="fizz-label fizz-space-between fizz-stack-16">{sideTitle[side]} Item
            {#if curAlt}
              <button class="fizz-button-small" on:click={() => swapDefaults(side)}>Make Default</button>
              <Icon
                width="16"
                height="16" onPress={() => deleteProductPairSide(side, true)}
                type="Trash" extraClassNames='cursor-pointer'
              ></Icon>
            {/if}
          </p>
          {#if !storefront.loading}
            <FeaturedProduct {storefront} {callbacks} orientation={side}
              alternative={true}></FeaturedProduct>
          {/if}
        </section>
      </dd>
    {/if}
  {/each}

{/if}